<template>
    <div class="page">
        <page-header :info='userInfo'></page-header>

        <div class="tex_box" v-if="page_status !== 0">
            <p v-if='page_status == 1'>您的企业资料已提交审核，将于两个工作日内完成审核</p>
            <p v-else-if='page_status == 2'>你的账户未开通管理权限，请联系企业管理员</p>

            <a target="_blank" href="http://www.qiqueqiao.com" class="a_button">返回首页</a>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../components/PageHeader"

import  { getUserInfo } from '../../libs/api/getUserInfo.js'

export default {
    name: "NotAllow",
    components: {
        PageHeader,
    },
    data(){
        return{
            userInfo: "",
            page_status: 0,      //1为审核中
        }
    },
    mounted(){
        let that = this;

        that.$loading();

        getUserInfo().then(res => {
            // console.log(res);
            this.userInfo = res.data;

            that.$loading().close();

            // 判断用户是否已有所属公司,若没有
            if(res.data.is_certified == 0){
                that.$router.push("/corcert");
            } 
            // 判断用户所属公司是否审核通过，若正在审核中
            else if(res.data.is_certified == 1){
                that.page_status = 1;
            }
            // 用户已有所属公司且公司审核通过
            else if(res.data.is_certified == 2){
                // 判断用户是否已被所属公司开通管理权限，若没有
                if(res.data.type == 3){
                    that.page_status = 2;
                } else {
                    that.$router.push("/index");
                }
            }
        })
    }
}
</script>

<style lang="stylus" scoped>
    .page
        width 100%
        height 100vh
        display flex
        flex-flow column
        align-items center
        background url('../../assets/images/login_bg.png') center center no-repeat
        background-size 100% 100%
        .tex_box
            width:900px;
            height:235px;
            background:rgba(255,255,255,1);
            box-shadow:0px 10px 40px 0px rgba(4,63,189,0.25);
            border-radius:5px;
            display flex
            flex-flow column
            align-items center
            justify-content center
            margin 130px 0 0
            p
                font-size 24px
                color #4174D7
                margin 0 0 40px 0
            .a_button
                width 137px
                height 36px
                font-size $smallFont
                color white
                background #4B96F3
                border-radius 4px
                text-align center
                line-height 36px
</style>




// WEBPACK FOOTER //
// src/pages/guide/NotAllow.vue